var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWechat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4375157_logo_wechat_icon 1",
    clipPath: "url(#clip0_400_7413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_71-wechat"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9999 4.99189C11.3029 4.99189 11.5989 5.01707 11.8909 5.05307C11.363 2.73478 8.92804 0.981211 6.00007 0.981211C2.68598 0.981211 0 3.22612 0 5.99457C0 7.59071 0.898053 9.00682 2.29099 9.9231L1.49997 11.5094L3.65485 10.5839C4.11694 10.7484 4.59712 10.8839 5.10999 10.947C5.0399 10.641 5.00007 10.3274 5.00007 10.0055C5.00007 7.24097 7.69093 4.99189 10.9999 4.99189ZM8.00007 3.23707C8.41416 3.23707 8.74999 3.57394 8.74999 3.98918C8.74999 4.40455 8.4142 4.74118 8.00007 4.74118C7.58574 4.74118 7.25006 4.40455 7.25006 3.98918C7.25006 3.57391 7.58574 3.23707 8.00007 3.23707ZM4 4.74118C3.58585 4.74118 3.25002 4.40455 3.25002 3.98918C3.25002 3.57394 3.58588 3.23707 4 3.23707C4.41412 3.23707 4.75002 3.57394 4.75002 3.98918C4.74999 4.40455 4.41409 4.74118 4 4.74118Z",
    fill: "#51C332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.9999 10.0054C15.9999 7.79032 13.7607 5.99456 10.9998 5.99456C8.23885 5.99456 6 7.79032 6 10.0054C6 12.2203 8.23885 14.0161 10.9998 14.0161C11.4539 14.0161 11.8858 13.952 12.3048 13.8608L14.9999 15.0188L14.0678 13.1509C15.2359 12.4168 15.9999 11.2879 15.9999 10.0054ZM9.4999 9.7547C9.08578 9.7547 8.74988 9.41797 8.74988 9.00253C8.74988 8.58729 9.08574 8.25066 9.4999 8.25066C9.91416 8.25066 10.2498 8.58743 10.2498 9.00253C10.2498 9.418 9.91409 9.7547 9.4999 9.7547ZM12.4998 9.7547C12.0855 9.7547 11.7499 9.41797 11.7499 9.00253C11.7499 8.58729 12.0855 8.25066 12.4998 8.25066C12.9141 8.25066 13.2498 8.58743 13.2498 9.00253C13.2498 9.418 12.9141 9.7547 12.4998 9.7547Z",
    fill: "#51C332"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_7413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWechat);
export default __webpack_public_path__ + "static/media/wechat.dc2277e2035babd39a8a6d34ddb8acbf.svg";
export { ForwardRef as ReactComponent };